export enum Months {
  JANUARY = 0,
  FEBRUARY = 1,
  MARCH = 2,
  APRIL = 3,
  MAY = 4,
  JUNE = 5,
  JULY = 6,
  AUGUST = 7,
  SEPTEMBER = 8,
  OCTOBER = 9,
  NOVEMBER = 10,
  DECEMBER = 11
}
export const MonthsTranslation = {
  [Months.JANUARY]: 'enum.months.january',
  [Months.FEBRUARY]: 'enum.months.february',
  [Months.MARCH]: 'enum.months.march',
  [Months.APRIL]: 'enum.months.april',
  [Months.MAY]: 'enum.months.may',
  [Months.JUNE]: 'enum.months.june',
  [Months.JULY]: 'enum.months.july',
  [Months.AUGUST]: 'enum.months.august',
  [Months.SEPTEMBER]: 'enum.months.september',
  [Months.OCTOBER]: 'enum.months.october',
  [Months.NOVEMBER]: 'enum.months.november',
  [Months.DECEMBER]: 'enum.months.december'
};
